import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Tag from '../tag/tag'
import { handleKeyPress } from '../../../utilities/keyHandler'

const scope = 'StreamInfo'
class StreamInfo extends Component {
  static propTypes = {
    login: PropTypes.string,
    name: PropTypes.string,
    game: PropTypes.string,
    avatar: PropTypes.string,
    thumbnail_url: PropTypes.string,
    viewer_count: PropTypes.number,
    online: PropTypes.number,
    featuredTitle: PropTypes.string,
  }

  constructor(props) {
    super(props)
    this.state = {
      expanded: false,
      userIgnore: false,
      tagIncludes: [],
      tagExcludes: [],
    }
    this.renderTagOptions = this.renderTagOptions.bind(this)
  }

  renderTime() {
    const { time } = this.props
    if (time) {
      const [hours, minutes] = time.split(':')
      return `${parseInt(hours, 10)}:${minutes}`
    }
    return null
  }

  renderTagOptions(tag) {
    const { includedTags, excludedTags } = this.props
    const { tagIncludes, tagExcludes } = this.state
    const tagRequired = includedTags.includes(tag.id)
      ? !tagIncludes.includes(tag.id) && !tagExcludes.includes(tag.id)
      : tagIncludes.includes(tag.id)
    const tagExcluded = excludedTags.includes(tag.id)
      ? !tagIncludes.includes(tag.id) && !tagExcludes.includes(tag.id)
      : tagExcludes.includes(tag.id)

    const removeFromArray = (arr, element) => {
      const index = arr.indexOf(element)
      if (index > -1) {
        arr.splice(index, 1)
      }
    }

    const onSelectInclude = id => {
      const includes = [...tagIncludes]
      const excludes = [...tagExcludes]
      if (includes.includes(id)) {
        removeFromArray(includes, id)
      } else {
        includes.push(id)
        removeFromArray(excludes, id)
      }
      this.setState({ tagIncludes: includes, tagExcludes: excludes })
    }

    const onSelectExclude = id => {
      const includes = [...tagIncludes]
      const excludes = [...tagExcludes]
      if (excludes.includes(id)) {
        removeFromArray(excludes, id)
      } else {
        excludes.push(id)
        removeFromArray(includes, id)
      }
      this.setState({ tagIncludes: includes, tagExcludes: excludes })
    }

    return (
      <Fragment key={tag.id}>
        <a
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            onSelectInclude(tag.id)
          }}
          title={`Require ${tag.text} Tag`}
          className={classnames(
            `${scope}-Options-Tags-Require`,
            `${scope}-Options-Tags-Button`,
            tagRequired && `${scope}-Options-Tags-Button-Selected`,
          )}
          tabIndex={0}
          onKeyPress={ev => handleKeyPress(ev, () => onSelectInclude(tag.id))}
        >
          <i className={classnames('fa fa-check')} />
        </a>
        <div className={`${scope}-Options-Tags-Name`}>
          <Tag>{tag.text}</Tag>
        </div>
        <a
          onClick={e => {
            e.preventDefault()
            e.stopPropagation()
            onSelectExclude(tag.id)
          }}
          title={`Exclude ${tag.text} Tag`}
          className={classnames(
            `${scope}-Options-Tags-Exclude`,
            `${scope}-Options-Tags-Button`,
            tagExcluded && `${scope}-Options-Tags-Button-Selected`,
          )}
          tabIndex={0}
          onKeyPress={ev => handleKeyPress(ev, () => onSelectExclude(tag.id))}
        >
          <i className={classnames('fa fa-times')} />
        </a>
      </Fragment>
    )
  }

  renderOptionsOverlay() {
    const { id, name, tags, onSaveOptions } = this.props
    const { expanded, userIgnore, tagIncludes, tagExcludes } = this.state
    if (!expanded) {
      return null
    }
    const saveOptions = () => {
      onSaveOptions(id, userIgnore, tagIncludes, tagExcludes)
      this.setState({ expanded: false, userIgnore: false, tagIncludes: [], tagExcludes: [] })
    }

    return (
      <Fragment>
        <div className={classnames(`${scope}-Options`)}>
          <div className={classnames(`${scope}-Options-Caption`)}>
            <a
              onClick={() => {
                this.setState({ userIgnore: !userIgnore })
              }}
              className={classnames(`${scope}-Options-Button`)}
              title={`${userIgnore ? 'Show' : 'Hide'} ${name}`}
              onKeyPress={ev => handleKeyPress(ev, () => this.setState({ userIgnore: !userIgnore }))}
              tabIndex={0}
            >
              {userIgnore ? 'Show' : 'Hide'} {name}
            </a>
          </div>
          <div className={classnames(`${scope}-Options-Content`)}>
            <div className={`${scope}-Options-Tags`}>{tags.map(tag => this.renderTagOptions(tag))}</div>
          </div>
          <div className={classnames(`${scope}-Options-Buttons`)}>
            <a onClick={saveOptions} tabIndex={0} onKeyPress={ev => handleKeyPress(ev, saveOptions)}>
              Save Options
            </a>
          </div>
          <div className={classnames(`${scope}-OptionButton`)}>
            <div
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                this.setState({ expanded: false, userIgnore: false, tagIncludes: [], tagExcludes: [] })
              }}
              title={'Close Options'}
              tabIndex={0}
              onKeyPress={ev => handleKeyPress(ev, () => this.setState({ expanded: !expanded }))}
            >
              <i className='fa fa-times' />
            </div>
          </div>
        </div>
      </Fragment>
    )
  }

  render() {
    const {
      className,
      login,
      name,
      title,
      tags,
      game,
      avatar,
      thumbnail_url,
      viewer_count,
      online,
      featuredTitle,
      blocked,
      cache,
    } = this.props
    const { expanded } = this.state
    const thumbnail = `${thumbnail_url}?cache=${cache}`
    return (
      <div className={classnames(scope, className)}>
        <a
          onDragStart={e => {
            e.preventDefault()
          }}
          draggable={false}
          title={title}
          rel='noopener noreferrer'
          target='_blank'
          href={`https://twitch.tv/${login}`}
          className={classnames(
            `${scope}-Container`,
            blocked && `${scope}-Container_Blocked`,
            !online && `${scope}-Container_Offline`,
            expanded && `${scope}-Container_Expanded`,
            featuredTitle && `${scope}-Container_Featured`,
          )}
          tabIndex={expanded ? -1 : 0}
        >
          <img alt='' className={classnames(`${scope}-Avatar`)} src={avatar} />
          <div className={classnames(`${scope}-Name`, featuredTitle && `${scope}-Name_Featured`)} title={name}>
            {featuredTitle ? <i className='fa fa-star' title={featuredTitle} /> : null}
            {name}
          </div>
          <img
            alt=''
            className={classnames(`${scope}-Thumbnail`)}
            src={thumbnail || 'https://via.placeholder.com/640x360/000000/FFFFFF/?text=Currently Offline'}
          />
          {!online ? null : (
            <Fragment>
              <div className={classnames(`${scope}-Game`)} title={game}>
                {game || 'No Game Selected'}
              </div>
              <div className={classnames(`${scope}-Viewers`)}>
                <i className='fa fa-user' />
                {viewer_count}
              </div>
              <div className={classnames(`${scope}-Time`)}>
                <i className='far fa-clock' />
                {this.renderTime()}
              </div>
              <div className={`${scope}-Title`}>
                {title}
                {tags ? (
                  <div className={`${scope}-Tags`}>
                    {tags.map(tag => (
                      <Tag key={tag.id}>{tag.text}</Tag>
                    ))}
                  </div>
                ) : null}
              </div>
            </Fragment>
          )}
          <div className={classnames(`${scope}-OptionButton`)}>
            <div
              onClick={e => {
                e.preventDefault()
                e.stopPropagation()
                this.setState({ expanded: !expanded })
              }}
              title={'Set Options'}
              tabIndex={expanded ? -1 : 0}
              onKeyPress={ev => handleKeyPress(ev, () => this.setState({ expanded: !expanded }))}
            >
              <i className='fa fa-bars' />
            </div>
          </div>
        </a>
        {this.renderOptionsOverlay()}
      </div>
    )
  }
}

export default StreamInfo



// WEBPACK FOOTER //
// ./src/components/common/stream-info/stream-info.jsx